import { NumUtils } from '@/modules/common/utils';

const createVehicleTypeId = (name: string) => `${name.replaceAll(' ', '_')}`;

export const transformRestVehiclesToVehicles = (
  restVehicles: UnifiedVehicleRestModel[],
): UnifiedVehicle[] =>
  restVehicles.map((v) => ({
    id: createVehicleTypeId(v.name),
    databaseId: v.id,
    name: v.name,
    vendor: v.vendor,
    model: v.model,
    hue: v.hue,
    image: {
      url: v.image.url,
    },
    tags: v.tags,
    uvt: {
      path: v.uvt?.path || null,
    },
    kmMdb: {
      path: v.kmMdb?.path || null,
    },
    category: v.category ?? null,
  }));

interface UnifiedVehicleRestModel {
  id: number;
  name: string;
  vendor: string;
  model: string;
  hue: number;
  tags: Tag[];
  image: VehicleImage;
  kmMdb?: Asset;
  uvt?: Asset;
  category?: 'STEER_DRIVE' | 'DIFF_DRIVE' | 'OMNI_DRIVE';
}

export type UnifiedVehicle = {
  databaseId: number;
  id: string;
  name: string;
  vendor: string;
  model: string;
  hue: number;
  tags: Tag[];
  image: VehicleImage;
  kmMdb: Asset;
  uvt: Asset;
  category: 'STEER_DRIVE' | 'DIFF_DRIVE' | 'OMNI_DRIVE' | null;
};

interface Tag {
  name: string;
  value: string;
}

export interface FileReferenceResponse {
  uvt?: string | null;
  kmMdb?: string | null;
};

type Asset = {
  path: string | null;
};

type VehicleImage = {
  url: string;
};

type LoadCarrierRestModel = {
  id: number;
  name: string;
  databaseId: number;
  width: number;
  height: number;
  length: number;
  weight: number;
  safeWorkLoad: number;
  image: {
    url: string;
    width: number;
    height: number;
  };
  carrierType: string; // called "carrierType in pimcore... needs the key category for unified unifiedLoadType"
};

export const convertRestLoadCarrierToModel = (v: LoadCarrierRestModel): LoadCarrier => ({
  id: v.name,
  name: v.name,
  databaseId: v.id,
  width: NumUtils.mmToMeters(v.width),
  height: NumUtils.mmToMeters(v.height),
  length: NumUtils.mmToMeters(v.length),
  weight: v.weight,
  category: v.carrierType,
  safeWorkingLoad: v.safeWorkLoad,
  image: {
    height: v.image.height,
    width: v.image.width,
    url: v.image.url,
  },
});

export type LoadCarrier = {
  id: string;
  name: string;
  databaseId: number;
  width: number;
  height: number;
  length: number;
  weight: number;
  category: string;
  safeWorkingLoad: number;
  image: {
    url: string;
    height: number;
    width: number;
  };
};
